import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Carouselhome from '../home/carousel-home';
import TE1 from '../../images/Project_Images/TEarthmovers1.webp';
import TE2 from '../../images/Project_Images/TEarthmovers2.webp';
import TE3 from '../../images/Project_Images/Tearthmovers3.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function ProjectTEarthmovers() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    return (
        <>
            <Helmet>
                <title>About Our Thriveni Earthmovers Pvt. Ltd Acoustics Project</title>
                <meta name="description" content="" />
                <meta property="og:title" content="Thriveni Earthmovers Pvt. Ltd" />
                <meta property="og:description" content="Supply and installation of customised acoustic solutions." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/TEarthmovers1.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-tearthmovers" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-tearthmovers" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={TE1} className="img-fluid" alt="TEarthmovers1" />
                                            </div>
                                            <div className="slide">
                                                <img src={TE2} className="img-fluid" alt="TEarthmovers2" />
                                            </div>
                                            <div className="slide">
                                                <img src={TE3} className="img-fluid" alt="TEarthmovers3" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch slider-arrow" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch slider-arrow" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>Thriveni Earthmovers Pvt. Ltd, Salem</h3>
                                    <p className="note">Location: Salem, Tamil Nadu</p>
                                    <p><strong>About Thriveni Earthmovers Pvt. Ltd Acoustic Project</strong>
                                        <br />Thriveni Earthmovers Private Limited (TEMPL) is one of India's leading mine development and infrastructure engineering companies, headquartered in Salem, Tamil Nadu. Established in 1999, the company has evolved into a diversified mining and infrastructure enterprise with operations across India, Indonesia, and Africa.<br />
                                    </p>
                                    <p>
                                        <strong>Our Scope</strong>
                                        <br />Acoustical Surfaces Industries engineered and executed a high-performance soundproof wall system for the Board Room, creating a confidential executive workspace with enhanced speech privacy and acoustic comfort.<br /><br />
                                        The wall system comprised a multi-layer sound isolation assembly incorporating LEED-eligible Echo Eliminator™ acoustic insulation for cavity damping, Noise Stop Vinyl Barrier™ to enhance airborne sound isolation, and MR plywood as the structural backing layer, all supported on a precision-engineered GI framing system. The integrated assembly was designed to reduce airborne sound transmission, suppress cavity resonance, and improve the overall acoustic performance of the enclosure.<br /><br />
                                        To optimize the interior acoustic environment, the wall surfaces were finished with Fabrisorb™ fabric-wrapped acoustic panels and D'ecoWood™ grooved PET wood panels. These architectural acoustic treatments were carefully integrated to control reverberation, enhance speech intelligibility, and complement the premium executive interior with a refined architectural finish.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    )
}

export default ProjectTEarthmovers